import styled from "styled-components";

export const HomeUI = styled("div")`
  width: 100%;
  height: calc(100vh - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fbda00;
  background: black;
`;
